<template>
  <div>
    <v-text-field
      ref="fileTextField"
      v-model="filename"
      :label="label"
      :placeholder="placeholder"
      :required="required"
      :persistent-hint="persistentHint"
      :hint="hint"
      :disabled="disabled"
      prepend-icon="mdi-paperclip"
      single-line
      :class="{[fieldClass]: true}"
      @click.native="onFocus"
    />
    <input
      ref="fileInput"
      :accept="accept"
      :multiple="multiple"
      :disabled="disabled"
      type="file"
      @click.stop
      @dragover="$emit('dragover')"
      @dragleave="$emit('dragleave')"
      @change="onFileChange"
    >
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, String],
      default: null
    },
    accept: {
      type: String,
      default: '*'
    },
    label: {
      type: String,
      default: 'choose_file'
    },
    placeholder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    'persistentHint': {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fieldClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filename: ''
    }
  },
  watch: {
    value(v) {
      this.filename = v
      if (!v) { this.$refs.fileInput.value = '' }
    }
  },
  mounted() {
    this.filename = this.value
  },
  methods: {
    getFormData(files) {
      const forms = []
      for (const file of files) {
        const form = new FormData()
        form.append('data', file, file.name)
        forms.push(form)
      }
      return forms
    },
    onFocus() {
      if (!this.disabled) {
        this.$refs.fileInput.click()
      }
    },
    onFileChange($event) {
      const files = $event.target.files || $event.dataTransfer.files
      const form = this.getFormData(files)
      if (files) {
        if (files.length > 0) {
          this.filename = [...files].map(file => file.name).join(', ')
        } else {
          this.filename = null
        }
      } else {
        this.filename = $event.target.value.split('\\').pop()
      }
      this.$emit('input', this.filename)
      this.$emit('formdata', form)
      this.$emit('files', files)
    }
  }
}
</script>

<style scoped>

  input[type=file] {
    opacity: 0;
    position:absolute;
    width:100%;
    height:100%;
    left:0;
    top: 0;
    cursor: pointer;
  }

</style>
